import { createMutation, createQuery } from 'react-query-kit';

import * as Types from '../api/subscription/types.api';
import * as API from '../api/subscription/index.api';

//
//

const key = 'subscriptions';

//

export const useQuerySubscriptionsList = createQuery<Types.SubscriptionsResponse, void>({
  queryKey: [key, 'list'],
  fetcher: () => API.getSubscriptionPlansAPI(),
});

//

export const useQueryMerchantSubscriptionGet = createQuery<
  Types.MerchantSubscriptionsResponse,
  Types.SubscriptionsQuery
>({
  queryKey: [key, 'merchant'],
  fetcher: (params) => API.getSubscriptionsAPI(params),
});

//

export const useMutationSaasSubUpdate = createMutation<
  any,
  Types.CreateUpdateToAnnualSaasSubscriptionLink
>({
  mutationKey: [key, 'create-checkout-session'],
  mutationFn: (params) => API.updateSaasSubscriptionAPI(params),
});

//

export const useMutationSaasSubCreate = createMutation<
  any,
  Types.CreateCheckoutSessionSaasPayload
>({
  mutationKey: [key, 'create-checkout-session'],
  mutationFn: (params) => API.createSaasSubscriptionAPI(params),
});
